import axios from "axios";
import { IZILIFE_AUTH_API, MAIN_API_URL } from "../config/api";

export const authService = {
  // Login : Appel Izilife Pay puis Izi CallCenter
  async login(email: string, password: string) {
    try {
      // 1. Appel direct à Izilife Pay
      const izilifeResponse = await axios.post(`${IZILIFE_AUTH_API}/user/login`, {
        email,
        password,
      });

      // 2. Récupérer le token Izilife
      const izilifeToken =
        izilifeResponse.data?.data?.data?.token || izilifeResponse.data?.data?.token || izilifeResponse.data?.token;

      if (!izilifeToken) {
        throw new Error("Token Izilife non reçu");
      }

      // 3. Envoyer le token à Izi CallCenter
      const callCenterResponse = await axios.post(`${MAIN_API_URL}/auth/login`, {
        izilife_token: izilifeToken,
      });

      // 4. Retourner les deux tokens
      return {
        ...callCenterResponse.data,
        izilife_token: izilifeToken,
      };
    } catch (error: any) {
      console.error("Erreur de login:", error);
      throw error;
    }
  },

  async loginWithApple(data: { email: string; id_token: string; fcm_token: string }) {
    try {
      const response = await axios.post(`${IZILIFE_AUTH_API}/user/login/apple`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async loginWithGoogle(data: { email: string; id_token: string; fcm_token: string }) {
    try {
      const response = await axios.post(`${IZILIFE_AUTH_API}/user/login/google`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async exchangeGoogleCode(code: string) {
    try {
      const response = await axios.post(`${MAIN_API_URL}/auth/google/exchange`, { code });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async loginWithIzilifeToken(izilifeToken: string) {
    try {
      const response = await axios.post(`${MAIN_API_URL}/auth/login-with-token`, {
        izilife_token: izilifeToken,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async register(data: {
    first_name: string;
    last_name: string;
    email: string;
    phonenumber?: string;
    password: string;
    password_confirmation: string;
    country_id: any;
  }) {
    try {
      const response = await axios.post(`${IZILIFE_AUTH_API}/user/register`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async verifyOtp(data: { email: string; otp: string }) {
    try {
      const response = await axios.post(`${IZILIFE_AUTH_API}/user/verify-code`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async resendOtp(data: { email: string }) {
    try {
      const response = await axios.post(`${IZILIFE_AUTH_API}/user/verify-code`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCurrentUser(token: string, izilifeToken: string): Promise<any> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/auth/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Izilife-Token": izilifeToken,
        },
      });
      return response.data.data;
    } catch (error) {
      console.error("Erreur lors de la récupération de l'utilisateur connecté :", error);
      throw error;
    }
  },

  async logout(token: string): Promise<void> {
    try {
      await axios.post(
        `${MAIN_API_URL}/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Erreur lors de la déconnexion :", error);
      throw error;
    }
  },
};
